import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { LoadingService } from '../services/shared-services/loading.service';
import { inject } from '@angular/core';
import { finalize, Observable } from 'rxjs';




export function networkInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
 debugger;
  const loader = inject(LoadingService);
  loader.show();
  let totalRequests = 0;
  let requestsCompleted = 0;
  requestsCompleted++;
  return next(req).pipe(
    finalize(() => {

      console.log(requestsCompleted, totalRequests);
      loader.hide();
      // if (requestsCompleted === totalRequests) {
      //   loader.hide();
      //   totalRequests = 0;
      //   requestsCompleted = 0;
      // }
    })
  );;
}